import { useState } from 'react';
import { demeterUsersApi } from '../../../../../Apis/Apis';
import { DemeterUserModel } from '../../../../../Generated/Raven-Demeter';
import useApiWithoutAutoExecute from '../../../../Apis/Hooks/useApiWithoutAutoExecute';
import ConfirmModal from '../../../../Components/Modals/ConfirmModal/ConfirmModal';
import ActionsCellButton from '../../../../Components/Tables/ActionsCellButton/ActionsCellButton';
import useLanguage from '../../../../Services/Language/useLanguageHook';

interface IRejectUserProps {
    show: boolean;
    user: DemeterUserModel;
    handleConfirmed: () => any;
}

const RejectUser: React.FC<IRejectUserProps> = (props: IRejectUserProps) => {
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [translations] = useLanguage();

    const [, rejectDemeterUser] = useApiWithoutAutoExecute(() => demeterUsersApi.rejectDemeterUser(props.user.demeterUserTrialGuid));

    if (!props.show) {
        return null;
    }

    return (
        <>
            <ActionsCellButton
                text={translations.users.actions.reject}
                handleClick={() => setShowConfirmModal(true)}
                track={{ eventCategory: 'User', eventAction: 'RejectClicked' }}
            />
            <ConfirmModal
                header={translations.users.text.confirmRejectHeader}
                message={translations.users.text.confirmRejectMessage}
                showModal={showConfirmModal}
                handleConfirm={async () => {
                    rejectDemeterUser();
                    props.handleConfirmed();
                    setShowConfirmModal(false);
                }}
                handleCancel={() => {
                    setShowConfirmModal(false);
                }}
                track={{ eventCategory: 'User', eventAction: 'ModalReject' }}
            />
        </>
    );
};

export default RejectUser;
